import React from 'react';
import { motion } from 'framer-motion';

const Vision = () => {
  return (
    <section id="vision" className="py-16 bg-offWhite">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <h2 className="font-display text-h2 text-secondary mb-2">OUR VISION</h2>
          <h3 className="font-display text-h3 text-primary mb-6">Making A Difference</h3>
          <div className="w-16 h-1 bg-cta mx-auto"></div>
        </div>
        
        <div className="max-w-4xl mx-auto mb-16 bg-primary/10 rounded-xl p-6 md:p-8 text-center">
          <p className="text-bodyLarge text-secondary font-medium italic">
            As of 2024, the global refugee population has surged to over 35 million (UNHCR), 
            with more than half being children under 18.
          </p>
        </div>
        
        <div className="mb-16 bg-white rounded-xl p-8 md:p-10 shadow-sm">
          <div className="max-w-3xl mx-auto">
            <h3 className="font-display text-h3 text-secondary mb-6">Our Mission</h3>
            
            <p className="text-bodyRegular text-textPrimary mb-6">
              The mission of Students for Refugees is to champion awareness and education 
              about the ongoing refugee crisis caused by persecution, conflict, violence, 
              and human rights violations. We strive to deepen understanding of migration issues—pre-migration, 
              transmigration, and post-migration.
            </p>
            
            <p className="text-bodyRegular text-textPrimary mb-6">
              Our organization empowers students to volunteer, advocate, and foster community 
              participation for this vulnerable population, in collaboration with numerous 
              agencies dedicated to assisting refugees.
            </p>
            
            <p className="text-bodyRegular text-textPrimary mb-6">
              Through engagement, our students will gain invaluable insights into resilience 
              and perseverance from the stories of the refugees they encounter.
            </p>
            
            <p className="text-bodyRegular text-textPrimary">
              Our goal is to build a international network of students committed to promoting 
              human rights, peace, and advocacy for displaced refugee children and their families, 
              starting in Houston, which proudly hosts the largest number of resettled refugees 
              in the United States.
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          <div className="bg-white p-6 rounded-xl shadow-sm">
            <div className="w-14 h-14 rounded-full bg-primary/20 flex items-center justify-center mb-4">
              <svg className="w-7 h-7 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
              </svg>
            </div>
            <h4 className="font-display text-h3 text-secondary mb-2">Advocacy</h4>
            <p className="text-textPrimary">Raising awareness about refugee issues and advocating for policy changes that support refugee communities.</p>
          </div>
          
          <div className="bg-white p-6 rounded-xl shadow-sm">
            <div className="w-14 h-14 rounded-full bg-primary/20 flex items-center justify-center mb-4">
              <svg className="w-7 h-7 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path>
              </svg>
            </div>
            <h4 className="font-display text-h3 text-secondary mb-2">Global Network</h4>
            <p className="text-textPrimary">Building an international community of students dedicated to supporting refugee education and integration.</p>
          </div>
          
          <div className="bg-white p-6 rounded-xl shadow-sm">
            <div className="w-14 h-14 rounded-full bg-primary/20 flex items-center justify-center mb-4">
              <svg className="w-7 h-7 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
              </svg>
            </div>
            <h4 className="font-display text-h3 text-secondary mb-2">Education</h4>
            <p className="text-textPrimary">Promoting understanding of refugee experiences and creating educational opportunities for displaced students.</p>
          </div>
        </div>
        
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="text-left">
            <p className="font-display text-h4 text-secondary">Imran Humza Hanif</p>
            <p className="text-bodyRegular text-primary font-medium">Founder and President</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;